<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 px-0">
      <nav class="navbar sticky-top main-nav px-3 py-4">
        <span
          class="back-button f-18 border-0 primary-font-bold"
          aria-label="Back navigation"
        >
          <img
            (click)="goHome()"
            src="/assets/icons/back-btn.svg"
            alt="back"
            class="mr-2"
          />
        </span>
        <button
          (click)="goToCheckout()"
          class="checkout-btn btn ml-auto f-14 primary-font-normal"
          type="button"
          matTooltip
          #tooltip="matTooltip"
          matTooltip="Ready to make payment? Tap the checkout button!"
          matTooltipPosition="right"
          aria-tooltip="Ready to make payment? Tap the checkout button!"
          title="Ready to make payment? Tap the checkout button!"
        >
          <img src="/assets/icons/checkout-icon.svg" alt="" class="mr-1" />
          Checkout
        </button>
      </nav>
      <div class="page-content">
        <div class="px-3 py-4">
          <div class="text-center mb-2">
            <p class="text-gray-500 primary-font-normal f-14">
              Thank you for your order
            </p>
          </div>
          <div class="star-lines mb-2">
            <p class="lines mb-0">
              <img src="/assets/icons/star.svg" class="star" alt="star" />
            </p>
          </div>

          <div>
            <app-order-items
              [isSuccessPage]="isSuccessPage"
              [dishes]="cart"
              [specialInstructions]="specialInstructions"
              (refreshCart)="handleCartRefresh($event)"
            ></app-order-items>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<button id="showToolTip" (click)="tooltip.show()" class="d-none"></button>

<div class="call-waiter-prompt sticky-btn">
  <img
    (click)="navMenuIsOpen = !navMenuIsOpen"
    [src]="navMenuIsOpen ? closeNavMenu : openNavMenu"
    alt="menu"
  />
</div>

<div class="call-waiter-actions sticky-btn" *ngIf="navMenuIsOpen">
  <button class="call-waiter-action primary-font-normal f-14" (click)="callWaiter()">
    <img src="/assets/icons/bing.svg" alt="move-table" />
    <span>Request a move table</span>
  </button>
  <button
    class="call-waiter-action primary-font-normal f-14"
    (click)="mergeTableBills()"
  >
    <img src="/assets/icons/bing.svg" alt="merge-bills" />
    <span>Merge table bills</span>
  </button>
  <button
    class="call-waiter-action primary-font-normal f-14"
    (click)="groupSplitBill()"
  >
    <img src="/assets/icons/bing.svg" alt="split-bill" />
    <span>Group split bill</span>
  </button>
</div>
